export const data = {
    name: "Directional",
    layout: [],
};
export default data;